import { createRoot } from 'react-dom/client';
const root = createRoot(document.getElementById('root')!);
// Participant mode must never load App, Cognito, react-admin or supervisor routes.
if (window.location.pathname === '/participant-intake') {
  void import('./intake/ParticipantIntake').then(({ ParticipantIntake }) => root.render(<ParticipantIntake />));
} else {
  void import('./App').then(({ default: App }) => root.render(<App />));
}
